import * as THREE from "three";
import TexturedMesh from "../TexturedMesh";

export default class Grass extends TexturedMesh {
  constructor(player) {
    const geometry = new THREE.PlaneBufferGeometry(10000, 10000);

    super(player, geometry, "phong");

    this.loadTexture({
      url: `${window.location.origin}/tour/assets/soil.jpg`,
    }).then(texture => {
      texture.wrapS = true;
      texture.wrapT = true;
      texture.repeat.set(100, 100);
    });
  }
}
